import { memo, useEffect, useMemo, useState } from "react";
import "./MasonryList.scss";
import { debounce } from "./Optimise";

export default memo(function MasonryList({ data, breakpointCols, defaultCols = 1, itemComponent, className, columnClassName }) {

    const [numCols, setNumCols] = useState(getNumColsForWidth(defaultCols, breakpointCols, window.innerWidth));

    const handleResize = useMemo(() => {
        return debounce(null, () => {
            const numCols = getNumColsForWidth(defaultCols, breakpointCols, window.innerWidth);
            setNumCols(numCols);
        }, 100);
    }, [breakpointCols, defaultCols]);
    
    useEffect(() => {
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        }
    }, [handleResize]);

    if(!data?.length) return <></>;

    const cols = [];
    for(let i = 0; i < numCols; ++i) {
        cols.push([]);
    }
    const colItems = weave(data, cols);

    const ItemComponent = itemComponent;

    return (
        <div className={`MasonryList ${className}`}>
            {colItems?.map((items, i) => (
                <div className={`MasonryList__col ${columnClassName}`} key={i}>
                    {items.map((item, i) => (
                        <ItemComponent key={item?.id ?? i} item={item} />
                    ))}
                </div>
            ))}
        </div>
    )
});

function weave(items, stripes) {
    for (let i = 0; i < items.length; ++i) {
        const item = items[i];
        const stripeIndex = i % stripes.length;
        stripes[stripeIndex].push(item);
    }

    return stripes;
}

function getNumColsForWidth(defaultCols, breakpointCols, screenWidth) {
    const numCols = Object.entries(breakpointCols)
        .find(([width]) => parseFloat(width) > screenWidth)?.[1]
        ?? defaultCols;
    
    return numCols
}